import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    resetPassword as resetPasswordAction,
    clearAuthNotification as clearAuthNotificationAction,
    setPassword as setPasswordAction,
    trackGetStartedClick as trackGetStartedClickAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
} from '../../actions/auth';
import {
    trackTermsOfServiceClicked as trackTermsOfServiceClickedAction,
    trackCommunityGuidelinesClicked as trackCommunityGuidelinesClickedAction,
    trackPrivacyPolicyClicked as trackPrivacyPolicyClickedAction,
} from '../../actions/gaTracking';
import {
    socialLogInUser as socialLogInUserAction,
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
} from '../../actions/social';

import ResetPasswordPage from './ResetPasswordPage';

const _mapStateToProps = (state) => ({
    locale: state.authentication.locale,
    socialSSOSettings: state.authentication.socialSSOSettings,
});

const _mapDispatchToProps = {
    handleResetPassword: resetPasswordAction,
    handleSetPassword: setPasswordAction,

    clearAuthNotification: clearAuthNotificationAction,
    onComunityGuidelinesClick: trackCommunityGuidelinesClickedAction,
    onGetStartedClick: trackGetStartedClickAction,
    onPrivacyPolicyClick: trackPrivacyPolicyClickedAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    onTermsOfServiceClick: trackTermsOfServiceClickedAction,
    onSocialLogInUser: socialLogInUserAction,
    onSocialLogInUserNotAuthorized: socialLogInUserNotAuthorizedAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(ResetPasswordPage),
);
